import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/apiClient";
import { ArrowLeft } from "lucide-react";

export default function ArticleDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/articles/${slug}`).then((r) => setArticle(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div data-testid="article-notfound" className="max-w-3xl mx-auto px-5 py-32 text-center">
        <h1 className="font-display text-4xl text-[#12495B]">Article introuvable</h1>
        <Link to="/actualites" className="mt-6 inline-flex text-[#12495B] font-semibold items-center gap-2">
          <ArrowLeft size={18} /> Retour aux actualités
        </Link>
      </div>
    );
  }

  if (!article) return <div className="py-40 text-center text-[#4B5563]">Chargement…</div>;

  return (
    <article data-testid="article-detail" className="pb-24">
      <div className="relative grain bg-[#12495B]">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 py-20">
          <Link to="/actualites" className="text-white/60 hover:text-white text-sm flex items-center gap-2 transition-colors duration-300">
            <ArrowLeft size={16} /> Retour aux actualités
          </Link>
          <span className="mt-8 block text-xs tracking-[0.2em] uppercase font-bold text-[#F5C518]">{article.category}</span>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl text-white tracking-tight leading-[1.1]">{article.title}</h1>
          <p className="mt-4 text-white/60 text-sm">
            {new Date(article.date).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <img src={article.image} alt={article.title} className="w-full h-auto rounded-2xl -mt-10 shadow-[0_20px_60px_rgb(0,0,0,0.15)]" />
        <div className="mt-12 space-y-6 text-lg text-[#111827] leading-relaxed">
          {article.content.split("\n\n").map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
      </div>
    </article>
  );
}
